import React from "react";
import NumberFormat from 'react-number-format';

const InternationalCurrency = ({ value, decimals, className, currencySymbol }) => {
    const number_of_decimals = decimals || 0;

    return (
        <NumberFormat
            className={className}
            value={value}
            displayType={'text'}
            thousandSeparator={true}
            prefix={currencySymbol}
            decimalScale={number_of_decimals}
            fixedDecimalScale={true}
        />
    )
};

export default InternationalCurrency;